/** @file React component that provides upload/download buttons for an ad request's file. */
import React from 'react';
import {ButtonGroup} from '@material-ui/core';
import DownloadAdButton from './DownloadAdButton';
import UploadAdButton from './UploadAdButton';
import UploadModal from './UploadModal';
import {useState} from 'react';

type Props = {
  userAuthToken: string,
  userEmailAddress: string,
  adKey: string,
  adFileKey: string
};

const AdFileOps: React.FC<Props> = (props: Props) => {
  const [uploadFileKey, setUploadFileKey] = useState('');

  return <>
    {uploadFileKey
      ? <UploadModal adFileKey={uploadFileKey}
                     isOpen={true}
                     onClose={(): void => setUploadFileKey('')}/>
      : <></>}

    <ButtonGroup
      color="primary"
      variant="text"
      size="small"
    >
      <DownloadAdButton
        apiToken={props.userAuthToken}
        user={props.userEmailAddress}
        adKey={props.adKey}/>
      <UploadAdButton
        apiToken={props.userAuthToken}
        fileKey={props.adFileKey}/>
    </ButtonGroup>
  </>;
};

export default AdFileOps;
